module.exports = __webpack_public_path__ + "img/19b2f296e23c09b951f8eff6c2d15275.png";